import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { DeviceUploadStatus, UploadStatus } from '../DevicesNewReducer';
import { Device } from '../../misc/api/DeviceLinkApi/Devices';
import * as classNames from 'classnames';
import './DeviceOverallUploadStatus.css';

export interface DeviceOverallUploadStatusProps {
    deviceStatus: Array<DeviceUploadStatus>;
    devices: Array<Device>;
}

export const DeviceOverallUploadStatus = (props: DeviceOverallUploadStatusProps) => {
    const duration = 4000,
        onEnter = node => {
            node.style.marginLeft = '300px';
            node.style.marginRight = '0px';
        },
        onEntering = node => {
            node.style.marginLeft = '';
            node.style.marginRight = '2px';
        }


    return (
        <TransitionGroup style={{ textAlign: 'left' }}>
            {props.deviceStatus.map(device => {
                const deviceMeta = props.devices.find(x => x.id === device.id);

                const labelClass = classNames('label', { 'label-info': device.status === UploadStatus.Uploading }, { 'label-success': device.status === UploadStatus.Uploaded }, { 'label-danger': device.status === UploadStatus.Failed }, { 'label-warning': device.status === UploadStatus.PartialFailed });
                const iconClass = classNames('fas', { 'fa-circle-notch fa-spin': device.status === UploadStatus.Uploading }, { 'fa-check': device.status === UploadStatus.Uploaded }, { 'fa-times': device.status === UploadStatus.Failed }, { 'fa-exclamation': device.status === UploadStatus.PartialFailed });

                return (
                    <CSSTransition key={deviceMeta.id} timeout={duration} onEnter={onEnter} onEntering={onEntering} classNames="device">
                        <span className={labelClass} style={{ marginRight: 2 + 'px' }}><i className={iconClass}></i> {deviceMeta.serial}</span>
                    </CSSTransition>
                );
            })}
        </TransitionGroup>
    );
}
